import { SET_CAMPAIGN_GROUP_PICKER_SORTING } from './actionTypes';

const setCampaignGroupPickerSorting = sortOption => ({
    type: SET_CAMPAIGN_GROUP_PICKER_SORTING,
    payload: sortOption,
});

export default setCampaignGroupPickerSorting;
